import { useEffect } from 'react'

/**
 * Hook to lock body scroll on mobile devices
 * Uses position: fixed technique for iOS compatibility
 * Only applies on mobile (width < tablet breakpoint)
 *
 * @param isLocked - Whether the body scroll should be locked
 */
export const useLockBodyScroll = (isLocked: boolean): void => {
  useEffect(() => {
    if (!isLocked) return

    // Save current scroll position and styles
    const scrollY = window.scrollY
    const originalOverflow = document.body.style.overflow
    const originalPosition = document.body.style.position
    const originalTop = document.body.style.top
    const originalWidth = document.body.style.width
    const originalTouchAction = document.body.style.touchAction

    // Prevent body scroll and touch dragging (works on iOS too)
    document.body.style.position = 'fixed'
    document.body.style.top = `-${scrollY}px`
    document.body.style.width = '100%'
    document.body.style.overflow = 'hidden'
    document.body.style.touchAction = 'none'

    return () => {
      // Restore original styles
      document.body.style.position = originalPosition
      document.body.style.top = originalTop
      document.body.style.width = originalWidth
      document.body.style.overflow = originalOverflow
      document.body.style.touchAction = originalTouchAction

      // Restore scroll position
      window.scrollTo(0, scrollY)
    }
  }, [isLocked])
}
